import React, { useState, useMemo } from "react";
import { Search } from "lucide-react";
import { Link } from "react-router-dom";
import productsData from "../data/products.json";
import "../styles/Produtos.css";

const Produtos = () => {
  const [selectedCategory, setSelectedCategory] = useState("todos");
  const [searchTerm, setSearchTerm] = useState("");

  const categories = [
    { id: "todos", name: "Todos os Produtos" },
    { id: "ambientes-externos", name: "Ambientes Externos" },
    { id: "assoalhos", name: "Assoalhos & Pisos" },
    { id: "cercas", name: "Cercas & Divisórias" },
    { id: "escadarias", name: "Escadarias" },
    { id: "interiores", name: "Interiores" },
    { id: "moveis", name: "Móveis Premium" },
  ];

  const getImage = (file) => require(`../assets/${file}`);

  // 🔍 Filtro inteligente
  const filteredProducts = useMemo(() => {
    const normalizedSearch = searchTerm.trim().toLowerCase();

    return productsData.filter((p) => {
      const matchesCategory =
        selectedCategory === "todos" || p.category === selectedCategory;

      if (!normalizedSearch) return matchesCategory;

      const searchWords = normalizedSearch.split(" ");
      const combinedText = `${p.title} ${p.description} ${p.category}`.toLowerCase();

      // Garante que todas as palavras da busca apareçam
      const matchesSearch = searchWords.every((word) =>
        combinedText.includes(word)
      );

      return matchesCategory && matchesSearch;
    });
  }, [productsData, selectedCategory, searchTerm]);

  const handleScrollContato = (e) => {
    e.preventDefault();
    const el = document.querySelector("#contato");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="produtos" className="prod-section">
      {/* Hero */}
      <div className="page-hero">
        <div className="page-hero__overlay" />
        <div className="page-hero__content">
          <h1 className="page-hero__title">Nossos Produtos</h1>
          <div className="page-breadcrumbs">
            <span className="page-breadcrumbs__link">Início</span>
            <span className="page-breadcrumbs__sep">›</span>
            <span className="page-breadcrumbs__current">Nossos Produtos</span>
          </div>
        </div>
      </div>

      <div className="prod-container">
        <div className="prod-grid">
          {/* Sidebar */}
          <aside className="prod-sidebar">
            {/* Search */}
            <div className="prod-card">
              <h3 className="prod-card__title">Pesquisar</h3>
              <div className="prod-search">
                <input
                  type="text"
                  placeholder="Digite sua busca..."
                  className="prod-search__input"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <Search className="prod-search__icon" size={18} />
              </div>
            </div>

            {/* Categories */}
            <div className="prod-card">
              <h3 className="prod-card__title">Categorias</h3>
              <nav className="prod-categories">
                {categories.map((category) => (
                  <button
                    key={category.id}
                    onClick={() => setSelectedCategory(category.id)}
                    className={`prod-cat-btn ${selectedCategory === category.id ? "is-active" : ""
                      }`}
                  >
                    {category.name}
                  </button>
                ))}
              </nav>
            </div>

            {/* CTA */}
            <div className="prod-card prod-card--wood">
              <h3 className="prod-card__title prod-card__title--light">
                Projeto Especial?
              </h3>
              <p className="prod-card__text">
                Desenvolvemos soluções personalizadas para atender suas
                necessidades específicas.
              </p>
              <a
                href="#contato"
                className="prod-btn"
                onClick={handleScrollContato}
              >
                Solicitar Orçamento
              </a>
            </div>
          </aside>

          {/* Products */}
          <div className="prod-results">
            <div className="prod-results__header">
              <p className="prod-results__count">
                Exibindo{" "}
                <span className="prod-results__count-strong">
                  {filteredProducts.length}
                </span>{" "}
                {filteredProducts.length === 1 ? "produto" : "produtos"}
              </p>
            </div>

            <div className="prod-cards">
              {filteredProducts.map((product) => (
                <Link
                  key={product.id}
                  to={`/produto/${product.id}`}
                  className="prod-card-item"
                >
                  <div className="prod-card-item__image">
                    <img
                      src={getImage(product.images[0])}
                      alt={product.title}
                    />
                    <div className="prod-card-item__overlay" />
                    <div className="prod-card-item__hover">
                      <span className="prod-chip">Ver Detalhes</span>
                    </div>
                  </div>

                  <div className="prod-card-item__body">
                    <h3 className="prod-card-item__title">{product.title}</h3>
                    <p className="prod-card-item__desc">
                      {product.description}
                    </p>
                  </div>
                </Link>
              ))}
            </div>

            {filteredProducts.length === 0 && (
              <div className="prod-empty">
                <p>Nenhum produto encontrado para sua busca.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Produtos;
